export enum SalesSubChannelTypesEnum {
  WEBSHOP = 'WEBSHOP',
  SELFORDER = 'SELFORDER'
}
